import $ from 'jquery';
import Viewport from './Viewport';

const SELECTOR = '.google-translate';
const GOOGLE_TRANSLATE = '.goog-te-gadget';

class Translate {
  constructor(element) {
    this.google = null;
    this.$element = $(element);
    this.change = this.change.bind(this);
    this.translateElement = this.translateElement.bind(this);
    this.$desktop = this.getDesktopPlacement();
    this.$mobile = this.getMobilePlacement();
    this.load();
  }

  getMobilePlacement() {
    return this.$element.find(`.header-bottom ${SELECTOR}`);
  }

  getDesktopPlacement() {
    return this.$element.find(`.header-top ${SELECTOR}`);
  }

  load() {
    // Load Google Translate framework.
    const script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateInit';
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(script);

    // Add window callback function to signal when the framework is ready.
    window.googleTranslateInit = () => {
      this.google = window.google;
      this.translateElement();
      this.listen();
    };
  }

  translateElement() {
    return new this.google.translate.TranslateElement(this.settings, 'google-translate');
  }

  listen() {
    Viewport.onChange(this.change);
    Viewport.requestTick();
  }

  change() {
    const $gt = this.$element.find(GOOGLE_TRANSLATE);
    const mode = Viewport.mobileState ? this.$mobile : this.$desktop;
    mode.append($gt);
  }

  get settings() {
    return {
      pageLanguage: 'en',
      layout: this.google.translate.TranslateElement.FloatPosition.BOTTOM_RIGHT,
    };
  }
}

export default Translate;



// WEBPACK FOOTER //
// ./Translate.js